import React from "react";
import logo from "../../assets/logo/atlas-logo.png";
import otto from "../../assets/images/login-posters/a-man-called-otto.webp";
import anotherEnd from "../../assets/images/login-posters/another-end.webp";
import blackBox from "../../assets/images/login-posters/black-box-diaries.webp";
import dangerous from "../../assets/images/login-posters/dangerous.webp";
import dawnPatrol from "../../assets/images/login-posters/dawn-patrol.webp";
import faster from "../../assets/images/login-posters/faster.webp";
import beethoven from "../../assets/images/login-posters/louis-van-beethoven.webp";
import madeOfHonor from "../../assets/images/login-posters/made-of-honor.webp";
import mama from "../../assets/images/login-posters/mama.webp";
import steelMagnolias from "../../assets/images/login-posters/steel-magnolias.webp";
import freeFall from "../../assets/images/login-posters/the-free-fall.webp";
import pirates from "../../assets/images/login-posters/the-pirates.webp";
import pursuit from "../../assets/images/login-posters/the-pursuit-of-happyness.webp";
import surfer from "../../assets/images/login-posters/the-surfer.webp";
import tailor from "../../assets/images/login-posters/the-tailor-of-panama.webp";
import "./LoginExperience.scss";

// Bundled catalogue artwork is available before authentication, without API calls.
const posters = [
  otto,
  faster,
  pirates,
  anotherEnd,
  steelMagnolias,
  surfer,
  pursuit,
  mama,
  blackBox,
  madeOfHonor,
  dangerous,
  beethoven,
  dawnPatrol,
  tailor,
  freeFall,
  pursuit,
  surfer,
  steelMagnolias,
  otto,
  mama,
  pirates,
  blackBox,
  anotherEnd,
  faster,
  beethoven,
  tailor,
  madeOfHonor,
  freeFall,
  dangerous,
  dawnPatrol,
  steelMagnolias,
  pirates
];

export default function LoginExperience({ children }) {
  return (
    <main className="atlas-signin">
      <div className="signin-backdrop" aria-hidden="true">
        <div className="signin-poster-wall">
          {posters.map((poster, index) => (
            <img
              key={index}
              src={poster}
              alt=""
              width="355"
              height="500"
              draggable="false"
            />
          ))}
        </div>
      </div>
      <header className="signin-header">
        <img className="signin-logo" src={logo} alt="Atlas" />
      </header>
      <div className="signin-content">
        <section className="signin-panel" aria-labelledby="signin-form-title">
          <div className="signin-form-wrap">{children}</div>
        </section>
      </div>
    </main>
  );
}
